module.exports = __webpack_public_path__ + "static/media/PolarDrift_Race.f8ca6cb0.gif";